export const TWO_FA_METHODS = {
  GOOGLE_AUTHENTICATOR: "google authenticator",
  EMAIL: "email",
  SMS: "sms",
};